var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryMarker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9832,
    cy: 17.9832,
    r: 17.9832,
    fill: "#219653"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_228080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3997 14.6586L30.8071 11.2512L21.2146 5.71094L18.0001 8.93047L14.7856 5.71094L5.18799 11.2512L8.59541 14.6586L5.18799 18.0711L8.80869 20.1582V24.9773L18.0001 30.2891L27.1915 24.9824V20.1633L30.8122 18.0711L27.3997 14.6586ZM14.6181 6.98047L17.1774 9.53984L14.7755 10.9262L15.2833 11.8047L18.0052 10.2305L20.7271 11.8047L21.2349 10.9262L18.8329 9.53984L21.3821 6.98047L29.1567 11.4695L26.5974 14.0289L23.9567 12.5055L23.4489 13.384L25.663 14.6637L17.995 19.0918L10.3271 14.6637L12.5411 13.384L12.0333 12.5055L9.39268 14.0289L6.8333 11.4695L14.6181 6.98047ZM9.82432 20.7473L14.7856 23.6113L16.9032 21.4937L16.1872 20.7777L14.6231 22.3418L6.84346 17.8527L9.40283 15.2934L17.4974 19.9652V28.8215L9.82432 24.3934V20.7473ZM26.1759 24.3934L18.5079 28.8215V19.9652L26.6024 15.2934L29.1618 17.8527L21.3872 22.3418L19.7521 20.7066L19.036 21.4227L21.2247 23.6113L26.186 20.7473V24.3934H26.1759Z",
    fill: "#D8DEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.946 11.9785L13.8564 11.4529L14.3642 12.3325L13.4539 12.858L12.946 11.9785Z",
    fill: "#D8DEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6306 12.3301L22.1384 11.4505L23.0487 11.9761L22.5409 12.8557L21.6306 12.3301Z",
    fill: "#D8DEF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_228080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMarker);
export default __webpack_public_path__ + "static/media/delivery_marker.a7663e26a45568807a05ba889c1df4d0.svg";
export { ForwardRef as ReactComponent };